<!-- 消息推送页面 -->
<template>
  <div>消息推送页面</div>
</template>

<script>
export default {
  data () {
    return {
    };
  },
  methods: {}
}

</script>
<style lang='scss' scoped>
</style>